module.exports = __webpack_public_path__ + "img/logo.cf1f7c4d.png";